export const generateSeoTitle = (title, tenantTitle) =>
  [title, tenantTitle].filter(Boolean).join(' | ');
